import './table.css';
import { useEffect, useState } from 'react';

export default function RateMyDay() {
  // Define color options with descriptions
  const colorOptions = [
    { color: '#91A6FF', description: 'Calm and Peaceful' },
    { color: '#FFE082', description: 'Happy and Cheerful' },
    { color: '#A0E4B0', description: 'Energized and Motivated' },
    { color: '#A9A9A9', description: 'Tired and Stressed' },
    { color: '#FFABAB', description: 'Passionate and Inspired' },
    { color: '#D4A5A5', description: 'Relaxed and Reflective' },
    { color: '#6A4C93', description: 'Sad and Melancholic' },
    { color: '#FFFFFF', description: 'Delete Cell' },
  ];

  // State for the table (31 rows x 12 columns)
  const [tableColors, setTableColors] = useState(
    () =>
      JSON.parse(localStorage.getItem('tableColors')) ||
      Array.from({ length: 31 }, () => Array(12).fill(null)),
  );

  // State to track the currently selected color
  const [selectedColor, setSelectedColor] = useState(
    () => localStorage.getItem('selectedColor') || null,
  );

  useEffect(() => {
    localStorage.setItem('tableColors', JSON.stringify(tableColors));
  }, [tableColors]);

  useEffect(() => {
    localStorage.setItem('selectedColor', selectedColor);
  }, [selectedColor]);

  // Handle color change for a specific cell
  const handleColorChange = (rowIndex, colIndex) => {
    if (!selectedColor) return; // Do nothing if no color is selected
    const newTableColors = [...tableColors];
    newTableColors[rowIndex][colIndex] = selectedColor;
    setTableColors(newTableColors);
  };

  return (
    <div>
      <div className="header-rate-day">
        <h1>Rate My Day</h1>
        <ol>
          <li>Pick a color from the options below</li>
          <li>Click on a cell to color your day</li>
          <li>See you again tomorrow </li>
        </ol>
      </div>
      <div className="table-container">
        {/* Table */}
        <table>
          <thead>
            <tr>
              <th>Day</th>
              {['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'].map(
                (month, index) => (
                  <th key={index}>{month}</th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {tableColors.map((row, rowIndex) => (
              <tr key={rowIndex}>
                <td>{rowIndex + 1}</td>
                {row.map((color, colIndex) => (
                  <td
                    key={colIndex}
                    onClick={() => handleColorChange(rowIndex, colIndex)}
                    style={{ backgroundColor: color }}
                  ></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Color Picker */}
        <div className="color-picker-container">
          <div className="color-picker">
            <h4>Select your mood</h4>
            {colorOptions.map(({ color, description }, index) => (
              <div
                key={index}
                onClick={() => {
                  console.log(`Color selected: ${color}`);
                  setSelectedColor(color);
                }}
              >
                <div
                  className={`color-box ${
                    selectedColor === color ? 'selected' : ''
                  }`}
                  style={{ backgroundColor: color }}
                ></div>
                <span className="color-picker-description">{description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
